<flex-col-center-center style="width: 100vw; height: 100vh; background: white">
  <div class="lds-dual-ring" style="width: 100px; height: 100px"></div>
</flex-col-center-center>
